import ZoomInIcon from '@atlaskit/icon/core/zoom-in';
import * as React from 'react';

export function SvgZoomIn() {
  return <ZoomInIcon label="" testId="ads-refreshed-icon" />;
}
